var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "trainRecords" } }, [
    _c("div", { attrs: { id: "container" } }),
    _vm._v(" "),
    _c("ul", { staticClass: "records first" }, [
      _c("li", [
        _c("div", { staticClass: "content" }, [
          _c("p", [
            !!_vm.cardStatistics.totalVideoLearnDuration &&
            _vm.cardStatistics.totalVideoLearnDuration / 60 < 1
              ? _c("span", [_vm._v("1")])
              : _c("span", [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        !!_vm.cardStatistics.totalVideoLearnDuration
                          ? (
                              _vm.cardStatistics.totalVideoLearnDuration / 60
                            ).toFixed(0)
                          : 0
                      ) +
                      "\n              "
                  )
                ]),
            _vm._v("\n              分钟\n            ")
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("课程听取")])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "content" }, [
          _c("p", [
            _c("span", [
              _vm._v(
                _vm._s(
                  !!_vm.cardStatistics.totalPracticeCount
                    ? _vm.cardStatistics.totalPracticeCount
                    : 0
                )
              )
            ]),
            _vm._v("次")
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("练习次数")])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "records" }, [
      _c("li", [
        _c("div", { staticClass: "content" }, [
          _c("p", [
            _c("span", [
              _vm._v(
                _vm._s(
                  !!_vm.cardStatistics.totalExamCount
                    ? _vm.cardStatistics.totalExamCount
                    : 0
                )
              )
            ]),
            _vm._v("次")
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("考试次数")])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "content" }, [
          _c("p", [
            _c("span", [
              _vm._v(
                _vm._s(
                  !!_vm.cardStatistics.accumulativeLearnDays
                    ? _vm.cardStatistics.accumulativeLearnDays
                    : 0
                )
              )
            ]),
            _vm._v("天")
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("学习天数")])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-578ee311", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-578ee311","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/trainRecords.vue
// module id = 1146
// module chunks = 0